export default __webpack_public_path__ + "static/media/psd.4d938409.svg";